import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SetChatUsernamesPipe } from './set-chat-usernames.pipe';



@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    SetChatUsernamesPipe
  ],
  exports: [
    SetChatUsernamesPipe
  ]
})
export class SetChatUsernamesModule { }
